import { fetchWrapper, objectToQueryParams } from '../utils';

export class moderator {
  static baseUrl = process.env.REACT_APP_BASE_API + 'moderator/maintenances';

  static async create(form) {
    return await fetchWrapper.post(this.baseUrl, form);
  }

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findOne(id) {
    const url = `${this.baseUrl}/${id}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/${id}/download`;
    return await fetchWrapper.get(url);
  }

  static async updateStatus(form) {
    const url = `${this.baseUrl}/status`;
    return await fetchWrapper.post(url, form);
  }
}

export class owner {
  static baseUrl = process.env.REACT_APP_BASE_API + 'owner/reports/maintenances';

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/${id}/download`;
    return await fetchWrapper.get(url);
  }
}
